module.exports = "float toDegrees = 57.2957795131;"